// src/Routes/AdminRoutes.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from '../Admin/componant/AdminLogin';
import AdminLayout from '../Admin/componant/AdminLayout';
import AdminDashboard from '../Admin/pages/AdminDashboard';
import CustomerManagement from '../Admin/pages/CustomerManagement';
import CustomerDetails from '../Admin/pages/CustomerDetails';
import AddTransaction from '../Admin/pages/AddTransaction';
import ActiveAlgos from '../Admin/pages/ActiveAlgos';
import SetPortfolio from '../Admin/pages/SetPortfolio';
import Investments from '../Customer/pages/Investments';

export const AdminRoutes = () => {
  return (
    <Routes>
      {/* /moti-lal -> Login Page */}
      <Route path="/" element={<AdminLogin />} />
     
      <Route element={<AdminLayout />}>
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="customers" element={<CustomerManagement />} />
        <Route path="customer/:id" element={<CustomerDetails />} />
        <Route path="add-transaction" element={<AddTransaction />} />
        <Route path="algos" element={<ActiveAlgos />} />
        <Route path="set-portfolio" element={<SetPortfolio />} />
       
      </Route>

      <Route path="*" element={null} />
    </Routes>
  );
};